import axios from 'axios'
import {services, getHeader, AES_KEY} from '@/assets/js/config.js'
import _ from 'lodash'
import moment from 'moment'
import crypto from 'crypto';
import { useConfigStore } from '@/stores/configStore'

export default () => {
	const setPaginate = (metaPage) => {
		return {
			perPageOptions: [5, 10, 25, 50, 100, 500],
			currentPage: (!isEmpty(metaPage) && !isEmpty(metaPage.current_page)) ? metaPage.current_page : 1,
			perPage: Number((!isEmpty(metaPage) && !isEmpty(metaPage.per_page)) ? metaPage.per_page : 25),
			total: (!isEmpty(metaPage) && !isEmpty(metaPage.total)) ? metaPage.total : 0,
			from: (!isEmpty(metaPage) && !isEmpty(metaPage.from)) ? metaPage.from : null,
			to: (!isEmpty(metaPage) && !isEmpty(metaPage.to)) ? metaPage.to : null
		}
	}
	// this method resets all the form values except for exclude items
	const setLocalStorage = (key,data,expired=86400) => {
		let nextExp = Math.floor(new Date().getTime()/1000.0) + expired;
		let d = {
			data:data,
			exp:nextExp
		}
		let lData = (_gAuth.appIsDemo()) ? JSON.stringify(d) : btoa(JSON.stringify(d));
		window.localStorage.setItem(key,lData);
	}
	const getLocalStorage = (key, defaultResp=null) => {
		let currTime = Math.floor(new Date().getTime()/1000.0);
		let d = window.localStorage.getItem(key);
		// _gNotif.cLog(d);
		if(isEmpty(d)) return defaultResp;

		d = (_gAuth.appIsDemo()) ? JSON.parse(d) : JSON.parse(atob(d));
	
		if(d.exp < currTime) return defaultResp;
		return d.data;
	}
	const patchData = (listItems,newItems,compareAttr = 'id') => {
		if(isEmpty(listItems)) return newItems;
		for (let i = 0; i < newItems.length; i++) {
			const element = newItems[i];
			let existElm = listItems.filter(itm=>{
				return itm[compareAttr] != element[compareAttr];
			})
			existElm.push(element);
			listItems = existElm;
		}
		return listItems;
	}
	const resetFormAttributes = (form, exclude = []) =>  {
		if(isEmpty(form)) return form;
		let cleanForm = {}
		Object.keys(form).forEach(key => {
				if (typeof form[key] === 'object') {
						cleanForm[key] = resetFormAttributes(form[key])
				} else {
						if(!exclude.includes(key)){
							cleanForm[key] = '';
						}else{
							cleanForm[key] = form[key];
						}
				}
		});
		return cleanForm;
} 
	const generateFormData = (data) => {
			let formData = new FormData()
			for(let property in data) {
					if(data[property] !== null){
							if(typeof data[property] === 'object' || Array.isArray(data[property])) {
									formData.append(property, JSON.stringify(data[property]));
							}else{
									formData.append(property, data[property]);
							}
					}
			}
			return formData
	}
	const generateQueryParams = (params) => {
		const searchParams = new URLSearchParams();
	
		const buildNestedParams = (obj, prefix = '') => {
			for (const key in obj) {
				if (obj.hasOwnProperty(key)) {
					const value = obj[key];
					const newKey = prefix ? `${prefix}[${key}]` : key;
	
					if (typeof value === 'object') {
						buildNestedParams(value, newKey);
					} else {
						if(isEmpty(value)) continue;
						
						searchParams.append(newKey, value);
					}
				}
			}
		};
	
		buildNestedParams(params);
	
		return searchParams.toString();
	}
	/**
	 * Builds a hierarchical structure from a flat list of objects.
	 */
	const generateGroupByParent = (listArrayObj, idKey = 'id', parentIdKey = 'parentId', childrenKey = 'children') => {
		if(isEmpty(listArrayObj)) return [];

		const result = [];

		let parents = listArrayObj.filter(itm => isEmpty(itm[parentIdKey]))	
		// Iterate through each item to populate the map
		parents.forEach(prnt => {
			let items = [];
			let foundIds = [];
			for (let idx = 0; idx < listArrayObj.length; idx++) {
				const el = listArrayObj[idx];
				if(prnt[idKey] === el[parentIdKey]){
					items.push(el);
					foundIds.push(el[idKey]);
				}
			}

			prnt[childrenKey] = sortByAttribute(items,'order');
			result.push(prnt);

			listArrayObj = listArrayObj.filter(rm => !foundIds.includes(rm[idKey]))
		});

		return sortByAttribute(result,'order');
	}
	const getSearchParams = (urlSearchParams, filters={}) => {
		if (isEmpty(filters)) return urlSearchParams;
		let searchParams = filters;
		for (const key in searchParams) {
			if (searchParams.hasOwnProperty(key)) {
				const value = searchParams[key];
				if (isEmpty(value)) {
					continue;
				}

				if (typeof value === 'object' && !Array.isArray(value)) {
					for (const subKey in value) {
						if (value.hasOwnProperty(subKey)) {
							urlSearchParams.append(`search[${key}][${subKey}]`, value[subKey]);
						}
					}
				} else {
					urlSearchParams.append(`search[${key}]`, value);
				}
			}
		}
		return urlSearchParams;
	}
	const createDownloadFileLink = (data, filename) => {
			const url = window.URL.createObjectURL(new Blob([data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', filename);
			link.addEventListener('click', () => {
					document.body.removeChild(link);
			});
			document.body.appendChild(link);
			link.click();
	}
	const checkRoleExists = (user_role_ids, role_ids) => {
			let has_role = false
			user_role_ids.forEach((role) => {
					if(role_ids.includes(role)){
							has_role = true
					}
			})
			return has_role
	}
	const checkAccess = (access_codes) => {
		let user_access_codes = _gAuth.activeUser('access_codes');
		if(!user_access_codes) return false;

		let intersect = _.intersection(user_access_codes,access_codes);
		return (intersect.length > 0);
	}
	const mustHasAccess = (access_codes) => {
		let user_access_codes = _gAuth.activeUser('access_codes');
		if(!user_access_codes || (access_codes.length == 0)) return false;

		// Get the intersection between currentAccess and requiredAccess
		const result = user_access_codes.filter(value => access_codes.includes(value));

		// Return true if all required access rights are present in currentAccess
		return result.length == access_codes.length;
	}
	const formatToMoney = (number) => {
			if(isEmpty(number)) return '';
			return parseFloat(number).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
	}
	const formatDate = (inputDate, outputFormat="Y-m-d H:i:s") =>  {
		if (inputDate == '' || inputDate === null) return inputDate;

		const date = new Date(inputDate);
		// Check if the date is valid
		if (isNaN(date)) {
			return '';
		}

		const day = String(date.getDate()).padStart(2, '0');
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const year = date.getFullYear();
		const hours = String(date.getHours()).padStart(2, '0');
		const minutes = String(date.getMinutes()).padStart(2, '0');
		const seconds = String(date.getSeconds()).padStart(2, '0');
		//ADD ANOTHER DATE PATERNS

		const patterns = {
			'Y': year,
			'm': month,
			'd': day,
			'H': hours,
			'i': minutes,
			's': seconds,
			//ADD ANOTHER PATERNS
		};

		//ADD ANOTHER PATERNS ON REPLACE REGEX
		return outputFormat.replace(/Y|m|d|H|i|s/g, match => patterns[match] || match);
	}
	const formatPhoneNumber = (no) => {
		
			// Remove non-numeric characters
			const cleanedNumber = no.replace(/\D/g, '');
		
			// // Check if the number starts with 62 (Indonesia)
			// if (cleanedNumber.startsWith('62')) {
			// 	return `+${cleanedNumber}`;
			// }
			// Check if the number starts with 60 (Malaysia)
			// else 
			if (cleanedNumber.startsWith('60')) {
				return `+${cleanedNumber}`;
			}
			// If the number starts with 0, replace it with 60 (Malaysia)
			else if (cleanedNumber.startsWith('0')) {
				return `+60${cleanedNumber.substr(1)}`;
			}
			// For other cases, return the original number
			else {
				return no;
			}
		
	}
	const getSlug = (str) => {
		if (isEmpty(str)) return "";
		str = str.replace(/([^A-Za-z0-9])/g, "-");
		str = str.replace(/([()])/g, "-");
		str = str.replace(/(-+)/g, "-");
		str = str.toLowerCase();
		return str;
	}
	const getUnSlug = (text) => {
		if (isEmpty(text)) return "";
		text = getSlug(text);
		text = text.replace(/(-+)/g, ' ');
		return text;
	};

	const getValue = (arrayData, dataPos = '', default_return = null) => {
		
		if (isEmpty(dataPos)) return default_return;
		if (isEmpty(arrayData)) return default_return;
		
		const pos = dataPos.split('.');
		let shakeData = arrayData;
	
		for (const p of pos) {
			if (isEmpty(shakeData) || !(p in shakeData)) {
				shakeData = default_return;
				break;
			}

			shakeData = shakeData[p];
		}
	
		if (shakeData === undefined || shakeData === null) {
			shakeData = default_return;
		}
	
		return shakeData;
	}

	const formatMomentDate = (inputDate, outputFormat="D MMM, YYYY h:mm A") =>  {
		if (isEmpty(inputDate)) return "-";
		return moment(inputDate).format(outputFormat);
	}
	const formatInitials = (name, max=3)  => {
		if(isEmpty(name)) return '';
		name = getUnSlug(name);
		const names = name.split(' ');
		let initials = '';
		const maxInitials = max;
		for (let i = 0; i < names.length && i < maxInitials; i++) {
				initials += names[i].charAt(0);
		}
		return initials.toUpperCase();
	}
	const formatLeadingZero = (n, l = 6) => {
		if (!isEmpty(n) && (typeof n == 'string' || typeof n == 'number'))  {
        n = n.toString().trim();
        let nl = n.length;
        if (nl >= l) return n;
        let zero = "0000";
        return zero.slice(0, (l - nl)) + n;
    } else {
        return '';
    }
	}
	const getCurrentDateTime = (include_time = true) =>  {
			const currentDate = new Date();
			const year = currentDate.getFullYear();
			const month = String(currentDate.getMonth() + 1).padStart(2, '0');
			const day = String(currentDate.getDate()).padStart(2, '0');
			const hours = String(currentDate.getHours()).padStart(2, '0');
			const minutes = String(currentDate.getMinutes()).padStart(2, '0');
			const seconds = String(currentDate.getSeconds()).padStart(2, '0');
			
			return include_time ? `${year}-${month}-${day} ${hours}:${minutes}:${seconds}` : `${year}-${month}-${day}`
	}
	const getDateDayDiff = (date) =>{
		return moment().diff(date, 'days');
	}
	const copyToClipboard = (text, notifTxt = "Link: {txt} copied to clipboard") => {
		navigator.clipboard.writeText(text)
			.then(() => {
				_gNotif.notifySuccess(notifTxt.replace("{txt}", text))
			})
			.catch(err => {
					console.error('Failed to copy text: ', err);
			});
	}
	const checkNonNumericInput = (event) => {
		// const keyCode = event.keyCode || event.which;
		// const keyValue = String.fromCharCode(keyCode);
		// const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
		// const allowedKeys = [8, 37, 38, 39, 40, 46];
		// if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
		// 	event.preventDefault();
		// }
		const allowed = ["Backspace", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Delete"];
		const regex = /^[\d.,$]$/;

		if (!regex.test(event.key) && !allowed.includes(event.key)) {
			event.preventDefault();
		}
	}
	const checkIsDateExpired = (dt) => {
			if(isEmpty(dt)) return true;
			
			let dtf = formatDate(dt);
			const currentDate = new Date();
			const checkDate = new Date(dtf);
			return currentDate > checkDate;
	}
	const compareDate = (start = null, end = null, operator = '>') => {
		if (isEmpty(start) || isEmpty(end)) return true;

		const startDate = new Date(formatDate(start));
		const endDate = new Date(formatDate(end));

		switch (operator) {
			case '>':
				return startDate > endDate;
			case '<':
				return startDate < endDate;
			case '>=':
				return startDate >= endDate;
			case '<=':
				return startDate <= endDate;
			case '==':
			case '=':
				return startDate.getTime() === endDate.getTime();
			case '!=':
				return startDate.getTime() !== endDate.getTime();
			default:
				console.warn(`Unknown operator: ${operator}`);
				return false;
		}
	};

	const checkAppCode = (app_code) => {
			let appCode = _gAuth.appCode();
			return appCode.includes(app_code)
	}
	const checkRoleType = (role_types)  => {
			let authUser = _gAuth.activeUser();
			return role_types.includes(authUser.account_info.role_type);
	}
	const checkAppCodeAndRoleType = (app_codes, role_types)  => {
			let has_role = false;
			let appCode = _gAuth.appCode();
			for (const app_code of app_codes) {
					if (appCode.includes(app_code) && role_types.includes(this.auth_user.account_info.role_type)) {
							has_role = true; // If any app_code matches and role_type is included, return true
					}
			}
			return has_role;
	}
	const checkAccessCodes = (current_user_access, route_required_access) => {
		if(!current_user_access) return false;
		let intersect = _.intersection(current_user_access,route_required_access);
		return (intersect.length > 0);
	}
	const checkIsCorporateSubscription = () => {
			let authUser = _gAuth.activeUser();
			return authUser.subscription.privileges.scpk_type.toLowerCase() === 'corporate'
	}
	const checkIsCorporatePackageSubscription = () => {
		let authUser = _gAuth.activeUser();
		return authUser.subscription.privileges.scpk_name.toLowerCase() === 'corporate' || authUser.subscription.privileges.scpk_name.toLowerCase() === 'team'
	}
	const isValidURL = (url) => {
    try {
        new URL(url);
        return true;
    } catch (e) {
        return false;
    }
	}
	const isEmpty = (param) => {
			if (param === '' || typeof param === 'undefined' || param === 'undefined' || param === 'null' || param === '[]' || param === '{}' || param === null || ((typeof param === 'object') && (Object.keys(param).length === 0))) {
					return true;
			} else {
					return false;
			}
	}
	const getUserInitials = (name)  =>  {
			if(name){
					const names = name.split(' ');
					let initials = '';
					const maxInitials = 3;
					for (let i = 0; i < names.length && i < maxInitials; i++) {
							initials += names[i].charAt(0);
					}
					return initials;
			}else{
					return name
			}
	}
	const convertFileToBase64 = async (file) => {
		return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onload = () => {
						resolve(reader.result);
				};
				reader.onerror = reject;
		});
	}
	const openNewTab = (url) => {
		const newTab = window.open(url, '_blank');
    
		// Make the newly opened tab active (if allowed by the browser)
		if (newTab) {
				newTab.focus();
		} else {
				// If the new tab couldn't be opened (e.g., due to pop-up blocker), provide a message
				_gNotif.cLog('New tab blocked. Please allow pop-ups for this site and try again.');
		}
	}
	// Encryption function
	const aesEncrypt = (text) => {
		const algorithm = 'aes-256-cbc';
		const iv = crypto.randomBytes(16);
		const cipher = crypto.createCipheriv(algorithm, Buffer.from(AES_KEY), iv);
		let encrypted = cipher.update(text);
		encrypted = Buffer.concat([encrypted, cipher.final()]);
		return iv.toString('hex') + ':' + encrypted.toString('hex');
	}
	// Decryption function
	const aesDecrypt = (text) => {
		const algorithm = 'aes-256-cbc';
		const textParts = text.split(':');
		const iv = Buffer.from(textParts.shift(), 'hex');
		const encryptedText = Buffer.from(textParts.join(':'), 'hex');
		const decipher = crypto.createDecipheriv(algorithm, Buffer.from(AES_KEY), iv);
		let decrypted = decipher.update(encryptedText);
		decrypted = Buffer.concat([decrypted, decipher.final()]);
		return decrypted.toString();
	}

	const getNumberColorClass = (val) => {
		return val < 0 ? "text-danger" : "text-success";
	}

	const setLoading = (section) => {
		useConfigStore().setLoading(section)
	}
	const removeLoading = (section) => {
		useConfigStore().removeLoading(section)
	}
	const isLoading = (section) => {
		let listLoading = useConfigStore().sectionLoadings
		if(isEmpty(listLoading)) return false
		return listLoading.includes(section)
	}
	const replacePlaceholders = (template, values) => {
    return template.replace(/{(\w+)}/g, (match, key) => {
        return typeof values[key] !== 'undefined' ? values[key] : match;
    });
	}
	const sortByAttribute = (arrayObject, attribute, order='asc') => {
		if(isEmpty(arrayObject) || !Array.isArray(arrayObject)) return arrayObject;
		
	  return arrayObject.sort((a, b) => {
        const extractLevel = (attr) => {
						if(isEmpty(attr)){
							attr = '-'
						}
            // Regular expression to capture numeric part and suffix
						const match = attr.toString().match(/^(\d+)([A-Z]*)$/);
						if(!isEmpty(match) && match.length > 2){
							return {
								number: parseInt(match[1], 10),
                suffix: match[2]
							};
						}else{
							return {
								number: '-',
								suffix: '-'
							};
						}
        };

        const levelA = extractLevel(a[attribute]);
        const levelB = extractLevel(b[attribute]);

        // Compare numeric parts
        if (levelA.number !== levelB.number) {
					if(order == 'asc'){
						return levelA.number - levelB.number;
					}else{
						return levelB.number - levelA.number;
					}
        }

        // Compare suffixes if numeric parts are equal
				if(order == 'asc'){
					return levelA.suffix.localeCompare(levelB.suffix);
				}else{
					return levelB.suffix.localeCompare(levelA.suffix);
				}
    });
	}

	return {
		setPaginate,
		setLocalStorage,
		getLocalStorage,
		patchData,
		resetFormAttributes,
		generateFormData,
		generateQueryParams,
		generateGroupByParent,
		getSearchParams,
		createDownloadFileLink,
		checkRoleExists,
		checkAccess,
		mustHasAccess,
		formatToMoney,
		formatDate,
		formatPhoneNumber,
		formatMomentDate,
		formatInitials,
		formatLeadingZero,
		getCurrentDateTime,
		getDateDayDiff,
		copyToClipboard,
		compareDate,
		checkNonNumericInput,
		checkIsDateExpired,
		checkAppCode,
		checkRoleType,
		checkAccessCodes,
		checkAppCodeAndRoleType,
		checkIsCorporateSubscription,
		checkIsCorporatePackageSubscription,
		isEmpty,
		isValidURL,
		getUserInitials,
		convertFileToBase64,
		aesEncrypt,
		aesDecrypt,
		openNewTab,
		getNumberColorClass,
		getSlug,
		getUnSlug,
		getValue,
		sortByAttribute,
		setLoading,
		removeLoading,
		isLoading,
		replacePlaceholders
	}
}
  